@if (config.enabled) {
  <section
    class="app-download"
    [class.app-download--compact]="compact"
    aria-label="Descarga aplicación móvil"
  >
    @if (!compact) {
      <h4 class="app-download__title">{{ config.title }}</h4>
    }

    <div class="app-download__stores">
      @if (config.ios.storeUrl) {
        <div class="store-card" [class.store-card--primary]="isPrimaryStore('ios')">
          <div class="store-card__content">
            @if (isPrimaryStore('ios') && isMobile) {
              <span class="store-card__badge">Recomendado para tu dispositivo</span>
            }
            @if (isMobile) {
              <a
                class="store-card__button"
                [href]="config.ios.storeUrl"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="'Descargar en ' + config.ios.buttonLabel"
              >
                @if (config.ios.buttonImageUrl) {
                  <img [src]="config.ios.buttonImageUrl" [alt]="config.ios.buttonLabel" />
                } @else {
                  <span class="store-card__fallback">
                    <i class="pi pi-apple" aria-hidden="true"></i>
                    {{ config.ios.buttonLabel }}
                  </span>
                }
              </a>
            } @else {
              <button
                type="button"
                class="store-card__button"
                [attr.aria-label]="'Ver QR para ' + config.ios.buttonLabel"
                (click)="onStoreAction('ios', $event)"
              >
                @if (config.ios.buttonImageUrl) {
                  <img [src]="config.ios.buttonImageUrl" [alt]="config.ios.buttonLabel" />
                } @else {
                  <span class="store-card__fallback">
                    <i class="pi pi-apple" aria-hidden="true"></i>
                    {{ config.ios.buttonLabel }}
                  </span>
                }
              </button>
            }
          </div>
        </div>
      }

      @if (config.android.storeUrl) {
        <div class="store-card" [class.store-card--primary]="isPrimaryStore('android')">
          <div class="store-card__content">
            @if (isPrimaryStore('android') && isMobile) {
              <span class="store-card__badge">Recomendado para tu dispositivo</span>
            }
            @if (isMobile) {
              <a
                class="store-card__button"
                [href]="config.android.storeUrl"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="'Descargar en ' + config.android.buttonLabel"
              >
                @if (config.android.buttonImageUrl) {
                  <img [src]="config.android.buttonImageUrl" [alt]="config.android.buttonLabel" />
                } @else {
                  <span class="store-card__fallback store-card__fallback--android">
                    <i class="pi pi-android" aria-hidden="true"></i>
                    {{ config.android.buttonLabel }}
                  </span>
                }
              </a>
            } @else {
              <button
                type="button"
                class="store-card__button"
                [attr.aria-label]="'Ver QR para ' + config.android.buttonLabel"
                (click)="onStoreAction('android', $event)"
              >
                @if (config.android.buttonImageUrl) {
                  <img [src]="config.android.buttonImageUrl" [alt]="config.android.buttonLabel" />
                } @else {
                  <span class="store-card__fallback store-card__fallback--android">
                    <i class="pi pi-android" aria-hidden="true"></i>
                    {{ config.android.buttonLabel }}
                  </span>
                }
              </button>
            }
          </div>
        </div>
      }
    </div>
  </section>

  <p-dialog
    [(visible)]="qrModalVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="true"
    [header]="qrModalTitle"
    styleClass="app-download-qr-dialog"
    [style]="{ width: 'min(92vw, 22rem)' }"
  >
    @if (activeQrImageUrl) {
      <div class="qr-modal">
        <img [src]="activeQrImageUrl" class="qr-modal__image" alt="Código QR de descarga" />
        <p class="qr-modal__hint">Escanea el código QR con tu móvil para descargar la app.</p>
        <p-button
          label="Abrir en la tienda"
          icon="pi pi-external-link"
          [outlined]="true"
          class="w-100"
          [style]="{ width: '100%' }"
          (onClick)="openStoreInBrowser()"
        />
      </div>
    }
  </p-dialog>
}
